/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Prices_Cash_CardInputs */

const en_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices shown as cash / card`)
};

const es_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios mostrados en efectivo / tarjeta`)
};

const de_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise: bar / mit Karte`)
};

const zh_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格显示为现金/卡`)
};

const ar_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار معروضة نقداً / ببطاقة`)
};

const fr_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix affichés en espèces / carte`)
};

const vi_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá hiển thị theo tiền mặt / thẻ`)
};

const sw_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei: taslimu / kadi`)
};

const th_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาที่แสดงเป็นเงินสด/บัตร`)
};

const bs_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene prikazane kao gotovina / kartica`)
};

const ja_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示価格：現金／カード`)
};

const ko_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격은 현금 / 카드 기준으로 표시됩니다`)
};

const pt_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços: dinheiro / cartão`)
};

const it_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi indicati come contanti / carta`)
};

const sv_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser som visas som kontant / kort`)
};

const nl_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen weergegeven als contant / kaart`)
};

const da_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser vist som kontanter / kort`)
};

const nb_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser vist som kontant / kort`)
};

const fi_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnat: käteinen / kortti`)
};

const pl_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny pokazane jako gotówka / karta`)
};

const ru_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены указаны как наличные / карта`)
};

const tr_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlar: nakit / kart`)
};

const hi_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य नकद / कार्ड के रूप में दिखाया गया`)
};

const id_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga yang ditunjukkan sebagai uang tunai / kartu`)
};

const ms_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga ditunjukkan sebagai tunai / kad`)
};

const cs_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny: hotově / kartou`)
};

const el_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι τιμές εμφανίζονται ως μετρητά / κάρτα`)
};

const he_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המחירים מוצגים במזומן / בכרטיס`)
};

const af_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pryse getoon as kontant / kaart`)
};

const hu_booking_prices_cash_card = /** @type {(inputs: Booking_Prices_Cash_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árak: készpénz / kártya`)
};

/**
* | output |
* | --- |
* | "Prices shown as cash / card" |
*
* @param {Booking_Prices_Cash_CardInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_prices_cash_card = /** @type {((inputs?: Booking_Prices_Cash_CardInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Prices_Cash_CardInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_prices_cash_card(inputs)
	if (locale === "de") return de_booking_prices_cash_card(inputs)
	if (locale === "zh") return zh_booking_prices_cash_card(inputs)
	if (locale === "ar") return ar_booking_prices_cash_card(inputs)
	if (locale === "fr") return fr_booking_prices_cash_card(inputs)
	if (locale === "vi") return vi_booking_prices_cash_card(inputs)
	if (locale === "sw") return sw_booking_prices_cash_card(inputs)
	if (locale === "th") return th_booking_prices_cash_card(inputs)
	if (locale === "bs") return bs_booking_prices_cash_card(inputs)
	if (locale === "ja") return ja_booking_prices_cash_card(inputs)
	if (locale === "ko") return ko_booking_prices_cash_card(inputs)
	if (locale === "pt") return pt_booking_prices_cash_card(inputs)
	if (locale === "it") return it_booking_prices_cash_card(inputs)
	if (locale === "sv") return sv_booking_prices_cash_card(inputs)
	if (locale === "nl") return nl_booking_prices_cash_card(inputs)
	if (locale === "da") return da_booking_prices_cash_card(inputs)
	if (locale === "nb") return nb_booking_prices_cash_card(inputs)
	if (locale === "fi") return fi_booking_prices_cash_card(inputs)
	if (locale === "pl") return pl_booking_prices_cash_card(inputs)
	if (locale === "ru") return ru_booking_prices_cash_card(inputs)
	if (locale === "tr") return tr_booking_prices_cash_card(inputs)
	if (locale === "hi") return hi_booking_prices_cash_card(inputs)
	if (locale === "id") return id_booking_prices_cash_card(inputs)
	if (locale === "ms") return ms_booking_prices_cash_card(inputs)
	if (locale === "cs") return cs_booking_prices_cash_card(inputs)
	if (locale === "el") return el_booking_prices_cash_card(inputs)
	if (locale === "he") return he_booking_prices_cash_card(inputs)
	if (locale === "af") return af_booking_prices_cash_card(inputs)
	if (locale === "hu") return hu_booking_prices_cash_card(inputs)
	return en_booking_prices_cash_card(inputs)
});